import { Space } from 'antd';
import { SpaceProps } from 'antd/lib/space';
import { usePermissions } from 'client/components/auth/AuthModule';
import { useRequestCompileContext } from 'client/components/schema/requests/compile-context/RequestCompileContext';
import { useRequestSteps } from 'client/components/schema/requests/compile-context/useRequestSteps';
import { ICreateRequestDto } from 'common/dto/RequestDto';
import { IRequest, RequestState } from 'common/schema/request/Request';
import { RequestMachine } from 'common/schema/request/RequestMachine';
import { WidgetDisposalStepLogic } from 'common/schema/widget/disposal/WidgetDisposalStepLogic';
import { useFormikContext } from 'formik';
import * as React from 'react';
import { ProcedureSaveButton } from './action-buttons/ProcedureSaveButton';
import { ProcedureStepBackButton } from './action-buttons/ProcedureStepBackButton';
import { ProcedureStepForwardButton } from './action-buttons/ProcedureStepForwardButton';
import { ProcedureSubmitButton } from './action-buttons/ProcedureSubmitButton';
import { RunDraftSave } from './useDraftSave';

export interface IProcedureActionButtonsProps {
  /** In anteprima, non controlliamo i permessi. */
  isPreview?: boolean;
  /** Richiesta già esistente */
  savedRequest?: IRequest | null;
  /** Esecuzione del salvataggio in bozza */
  draftSave?: RunDraftSave;
  /** Spacing */
  spaceProps?: Partial<SpaceProps>;
  children?: React.ReactNode;
}

export function ProcedureActionButtons(props: IProcedureActionButtonsProps) {
  const { isPreview, savedRequest, draftSave, spaceProps } = props;

  const permissions = usePermissions();
  const formik = useFormikContext<ICreateRequestDto>();
  const steps = useRequestSteps();

  /**
   * In caso di richiesta salvata, comunque non è possibile inviarla.
   */
  if (savedRequest && !RequestMachine.to(savedRequest, RequestState.Sent)) {
    return null;
  }

  const canSave = isPreview || permissions.has('request.write:own');

  // TODO Gestire in un modo migliore.
  const buttonsShownCount =
    (canSave ? 1 : 0) +
    (steps.previous ? 1 : 0) +
    (steps.next ? 1 : 0) +
    (steps.isLast ? 1 : 0);

  return (
    <Space
      {...spaceProps}
      direction={
        // Se è verticale, la manteniamo sempre (colonna destra)
        spaceProps?.direction === 'vertical'
          ? 'vertical'
          : buttonsShownCount >= 2
          ? 'horizontal' // Altrimenti, se ci sono due o più pulsanti è orizzontale
          : 'vertical' // Se invece è uno solo, lo mettiamo come vertical per avere un rendering migliore
      }
    >
      {/* Salvataggio domanda   steps.isFirst &&  */}
      {canSave && <ProcedureSaveButton onClick={() => draftSave?.(formik)} />}
      {/* Step back */}
      {steps.previous && (
        <ProcedureStepBackButton
          title={steps.previous.title}
          onBack={() => steps.setCurrentStep(steps.currentIndex - 1)}
        />
      )}
      {/* Step forward */}
      {steps.next && (
        <ProcedureStepForwardButton
          title={steps.next.title}
          steps={steps}
          formik={formik}
          isPreview={isPreview}
          onForward={() => steps.setCurrentStep(steps.currentIndex + 1)}
        />
      )}
      {/* Invio Domanda */}
      {steps.isLast && <ProcedureSubmitButton htmlType="submit" />}
      {props.children}
    </Space>
  );
}
